import React from "react"
import { BLOCKS } from "@contentful/rich-text-types"
import ImageHelper from "@components/ImageHelper"

export const withFinePrint = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const finePrint =
        children.length === 1 &&
        typeof children[0] === "string" &&
        children[0].trim()

      if (
        finePrint &&
        (finePrint.indexOf("<sub>") === 0 ||
          finePrint.indexOf("<sup>") === 0) &&
        (finePrint.indexOf("</sub>") !== -1 ||
          finePrint.indexOf("</sup>") !== -1)
      ) {
        return (
          <p className="finePrint">
            {finePrint
              .replace("</sub>", "")
              .replace("</sup>", "")
              .replace("<sub>", "")
              .replace("<sup>", "")}
          </p>
        )
      } else {
        return <p>{children}</p>
      }
    },
  },
}

export const withEmbeddedAsset = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      if (!node.data.target) {
        return null
      }
      return (
        <ImageHelper
          alt={node.data?.target?.fields?.description}
          src={`https://${node.data.target.fields.file.url}`}
        />
      )
    },
  },
}

export const withAllOptions = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => {
      const finePrint =
        children.length === 1 && typeof children[0] === "string" && children[0]

      if (
        finePrint &&
        (finePrint.indexOf("<sub>") === 0 ||
          finePrint.indexOf("<sup>") === 0) &&
        (finePrint.indexOf("</sub>") !== -1 ||
          finePrint.indexOf("</sup>") !== -1)
      ) {
        return (
          <p className="finePrint">
            {finePrint
              .replace("</sub>", "")
              .replace("</sup>", "")
              .replace("<sub>", "")
              .replace("<sup>", "")}
          </p>
        )
      } else {
        return <p>{children}</p>
      }
    },
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      if (!node.data.target) {
        return null
      }

      const url = node?.data?.target?.file?.url
      const isPdf = url && url.indexOf(".pdf") !== -1

      return isPdf ? (
        <p>
          <a href={`https://${url}`} target="_blank">
            {node.data.target.title}
          </a>
        </p>
      ) : (
        <ImageHelper
          alt={node.data.target.description || node.data.target.title}
          src={`https://${node.data.target.file.url}`}
        />
      )
    },
  },
}
